import {
  createBrowserRouter,
  RouterProvider,
  useNavigate
} from 'react-router-dom';
import './App.css';
import './components/navbars/indexNavbar';
import RootLayout from './components/views/root';
import { HomePage } from './components/views/home';
import TripsPage from './components/views/trips-page';
import PublicTripsPage from './components/views/public-trips-page';
import ErrorPage from './components/views/error';
import LoginForm from './components/login-form';
import ProfilePage from './components/views/profile-page';
import PublicProfilePage from './components/views/public-profile-page';
//import ActivityPage from './components/views/activity-page';
import TripInvitationsPage from './components/views/trip-invitations-page';
// import TripPage from './components/views/trip-page';
//import ActivitiesPage from './components/views/activities-page';
import FolderActivityPage from './components/views/folder-activity-page';
import SignupForm from './components/forms/signup-form';
import ForgotPasswordEmail from './components/views/forgot-password-email';
import ResetPassword from './components/views/reset-password';
//import ItinerariesPage from './components/views/itineraries-page';
//import TripOpenPage from './components/views/trip-open-page';
//import TripOpenPage2 from './components/views/trip-open-page2';
import TripOpenViewPage from './components/views/trip-open-view';
import TripOverview from './components/views/trip-overview';
import MapPage from './components/views/map-page';
// import ItineraryOpenPage from './components/views/itinerary-open-page';
//import SharedWithMePage from './components/views/shared-with-me-page';
import BucketListPage from './components/views/bucket-list-page/bucket-list-page';
import GeneralSettingsPage from './components/views/settings/general-page';
import SettingsPage from './components/views/settings/settings-page';
import ForgotYourPasswordPage from './components/views/settings/forgot-your-password-page';
import ChangeYourPasswordPage from './components/views/settings/change-password-page';
import NotificationSettingsPage from './components/views/settings/notification-settings-page';
import { DropdownProvider } from './contexts/DropdownContext';
import { AuthProvider } from './contexts/AuthContext';
import { WebSocketProvider } from './shared/contexts/WebSocketContext';
import { ProtectedRoute, AdminRoute } from './components/ProtectedRoute';
import { DiscoveryPage } from './components/Discovery';
import { FeedPage } from './components/Feed';
import { NotificationPreferences } from './components/Notifications';
import { getAuthToken } from './services/authentication.service';
import AdminIngestionPage from './components/admin/AdminIngestionPage';
import AdminAnalyticsPage from './components/admin/AdminAnalyticsPage';
import AdminDashboardPage from './components/admin/AdminDashboardPage';
import AdminAlertsPage from './components/admin/AdminAlertsPage';
import AdminErrorsPage from './components/admin/AdminErrorsPage';
import { TripReelPage } from './components/trips/trip-reel-page';

// Wrapper component for HomePage to handle navigation
function HomePageWrapper() {
  const navigate = useNavigate();

  const handleGetStarted = () => {
    navigate('/login');
  };

  const handleDownloadExtension = () => {
    window.open('https://chrome.google.com/webstore', '_blank');
  };

  return (
    <HomePage
      onGetStarted={handleGetStarted}
      onDownloadExtension={handleDownloadExtension}
    />
  );
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <HomePageWrapper />,
    errorElement: <ErrorPage />
  },
  {
    path: '/login',
    element: <LoginForm />,
    errorElement: <ErrorPage />
  },
  {
    path: '/signup',
    element: <SignupForm />,
    errorElement: <ErrorPage />
  },
  {
    path: '/forgot-password-email',
    element: <ForgotPasswordEmail />,
    errorElement: <ErrorPage />
  },
  {
    path: '/reset-password/:token',
    element: <ResetPassword />,
    errorElement: <ErrorPage />
  },
  {
    path: '/app',
    element: (
      <ProtectedRoute>
        <RootLayout />
      </ProtectedRoute>
    ),
    errorElement: <ErrorPage />,
    children: [
      { index: true, element: <TripsPage /> },
      { path: '/app/trips', element: <TripsPage /> },
      { path: '/app/trips/:id/', element: <TripOpenViewPage /> },
      { path: '/app/trips/:id/reel', element: <TripReelPage /> },
      {
        path: '/app/trips/:id/folders/:folderid?',
        element: <TripOpenViewPage />
      },
      {
        path: '/app/trips/:id/activities/:actviityid',
        element: <FolderActivityPage />
      },
      {
        path: '/app/trip/:id/view',
        element: <TripOpenViewPage />,
        children: [
          { index: true, element: <TripOverview /> },
          { path: '/app/trip/:id/view/:section', element: <TripOverview /> }
        ]
      },
      { path: '/app/public-trips', element: <PublicTripsPage /> },
      { path: '/app/bucket-list', element: <BucketListPage /> },
      { path: '/app/discovery', element: <DiscoveryPage /> },
      { path: '/app/feed', element: <FeedPage /> },
      { path: '/app/notifications', element: <NotificationPreferences /> },
      // { path: '/app/activities', element: <ActivitiesPage /> },
      // { path: '/app/activities/:id', element: <ActivityPage /> },
      { path: '/app/map/:id', element: <MapPage /> },
      { path: '/app/invitations', element: <TripInvitationsPage /> },
      // { path: '/app/invitations/:id', element: <TripOpenPage /> },
      { path: '/app/profile', element: <ProfilePage /> },
      { path: '/app/users/:userId', element: <PublicProfilePage /> },
      // { path: '/app/itineraries', element: <ItinerariesPage /> },
      // { path: '/app/itineraries/:id', element: <ItineraryOpenPage /> },
      // { path: '/app/shared-with-me', element: <SharedWithMePage /> },
      {
        path: '/app/admin/ingestion',
        element: (
          <AdminRoute>
            <AdminIngestionPage />
          </AdminRoute>
        )
      },
      {
        path: '/app/admin/analytics',
        element: (
          <AdminRoute>
            <AdminAnalyticsPage />
          </AdminRoute>
        )
      },
      {
        path: '/app/admin/errors',
        element: (
          <AdminRoute>
            <AdminErrorsPage />
          </AdminRoute>
        )
      },
      {
        path: '/app/admin',
        element: (
          <AdminRoute>
            <AdminDashboardPage />
          </AdminRoute>
        )
      },
      {
        path: '/app/admin/alerts',
        element: (
          <AdminRoute>
            <AdminAlertsPage />
          </AdminRoute>
        )
      },
      {
        path: '/app/settings',
        element: <SettingsPage />,
        children: [
          { path: '/app/settings/general', element: <GeneralSettingsPage /> },
          {
            path: '/app/settings/change-password',
            element: <ChangeYourPasswordPage />
          },
          {
            path: '/app/settings/notifications',
            element: <NotificationSettingsPage />
          }
        ]
      },
      {
        path: '/app/settings/forgot-password',
        element: <ForgotYourPasswordPage />
      }
    ]
  }
]);

function App() {
  const token = getAuthToken();

  return (
    <AuthProvider>
      <WebSocketProvider token={token}>
        <DropdownProvider>
          <RouterProvider router={router} />
        </DropdownProvider>
      </WebSocketProvider>
    </AuthProvider>
  );
}

export default App;
